import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  OAUTH_REDIRECT_STORAGE_KEY,
  sanitizeRedirectPath,
} from "../../utils/authRedirect";

const OAuthRedirectHandler = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      return;
    }

    const storedRedirectTo = window.sessionStorage.getItem(
      OAUTH_REDIRECT_STORAGE_KEY
    );

    if (!storedRedirectTo) {
      return;
    }

    window.sessionStorage.removeItem(OAUTH_REDIRECT_STORAGE_KEY);
    navigate(sanitizeRedirectPath(storedRedirectTo), { replace: true });
  }, [navigate, user]);

  return null;
};

export default OAuthRedirectHandler;
